import { NgModule } from '@angular/core';
import { PromptService } from './prompt.service';
import { AppRouterService } from './app-router.service';
import { AppSettingService } from './app-setting.service';
import { HttpRequestService } from './http-request.service';
import { LoginInfoService } from './login-info.service';
import { RfidreaderService } from './rfidreader.service';
import { TreeDataService } from './tree-data.service';
import { TableExportService } from './table-export.service';

@NgModule({
  providers: [
    AppRouterService,
    AppSettingService,
    HttpRequestService,
    LoginInfoService,
    RfidreaderService,
    TreeDataService,
    PromptService,
    TableExportService
  ]
})
export class ServiceModule { }
